import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { UnitOfWork } from "./unit-of-work";
import { UserPref } from "@/model/entities/user-pref";

/** Like layoutConfig in \src\app\layout\service\layout.service.ts */
export interface LayoutConfig {
  preset: string;
  primary: string;
  surface: string | undefined | null;
  darkTheme: boolean;
  menuMode: string;
  menuTheme: string;
  cardStyle: string;
}


@Injectable({ providedIn: 'root' })
export class UserPrefsService {
  private configString?: string;
  private config?: LayoutConfig;
  private pref?: UserPref;
  gridTheme = "ag-theme-alpine"; // Default matches Lara preset
  private hasLoaded = false;

  constructor(private uow: UnitOfWork, private authService: AuthService) {
  }

  setConfig(config: LayoutConfig) {
    this.setGridTheme(config);
    const json = JSON.stringify(config);
    if (json !== this.configString && this.hasLoaded) {
      this.config = config;
      this.configString = json;

      if (this.pref && this.authService.getUser()) {
        this.pref.prefsJson = this.configString;
      } else {
        this.pref = this.uow.createEntity(UserPref, {
          username: this.authService.getUser()?.loginName,
          prefsJson: this.configString
        });
      }
      // This row and nothing else. An argument-less commit saves every pending change in the
      // manager, so a preference written by a collapsing sidebar would also save whatever form the
      // operator happens to have open - half-filled, and judged by the server as if it were done.
      return this.uow.commit([this.pref]);
    }
    return undefined;
  }

  async getConfig() {
    if (!this.config && this.authService.getUser()) {
      const username = this.authService.getUser()?.loginName;
      const prefs = await this.uow.createQuery(UserPref).where({ username }).execute();
      if (prefs.length) {
        this.pref = prefs[0];
        const s = prefs[0].prefsJson;
        if (s) {
          this.configString = s;
          this.config = JSON.parse(s) as LayoutConfig;
          this.setGridTheme(this.config);
        }
      }
      this.hasLoaded = true;
    }
    return this.config;
  }

  private setGridTheme(config: LayoutConfig) {
    let theme = (config.preset == 'Lara') ? "ag-theme-alpine" : "ag-theme-balham";
    if (config.darkTheme) {
      theme += "-dark";
    }
    this.gridTheme = theme;
  }

}
